export const featuresCheck = (text: string, features: any[]) => {
  let answer = false;
  features?.map((feature) => {
    if (feature?.value?.includes(text)) answer = true;
  });
  return answer;
};
